import { render } from "./DataSourceFilterSelect.vue?vue&type=template&id=f634c3dc"
import script from "./DataSourceFilterSelect.vue?vue&type=script&lang=ts"
export * from "./DataSourceFilterSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script